import React from 'react';
import SelectSection from '../../layout/SelectSection';

import style from './SelectSectionPage.module.scss';

const SelectSectionPage = () => (
  <div className={style.wrapper}>
    <SelectSection />
  </div>
);

export default SelectSectionPage;
